// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle:after{content:normal}.footer-container--minisite{margin:auto;max-width:1230px;padding-left:15px;padding-right:15px}@media(min-width:992px){h3{font-size:16.38px}.subscriptn_offers{background-color:#ccc;border-radius:5px;height:100%;margin:20px auto;max-width:90%;min-height:100%;padding:10px;text-align:center;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
